export default {
  computed: {
    hours() {
      let hours = ""

      if (this.item.hours instanceof Array) {
        hours = this.item.hours.join("\n")
      }

      if (this.item.hours?.text) {
        hours = this.item.hours.text
      }

      if (hours.length > 60 && !this.expandHours) {
        hours = hours.substr(0, 60) + "..."
      }

      return hours
    },
  },
}
